import React from 'react'
import { Grid, RadioGroup, FormControlLabel, Radio } from '@material-ui/core'
import useStyles from '../styles'

function CategorySelector({ tagList, showCategories, setShowCategories, selectedTag, setSelectedTag }) {
  const classes = useStyles();

  const columns = [[], [], []]
  tagList.forEach((tag, index) => {
    columns[index % 3].push(tag)
  })

  const handleShowCategoriesChange = (event) => {
    const isYesSelected = event.target.value === "yes";
    setShowCategories(isYesSelected);
    
    if (!isYesSelected) {
      setSelectedTag("");
    }
  };

  return (
    <Grid className={classes.inputGroup}>
      <span>Adicionar categoria?</span>
      <RadioGroup
        row
        name="addCategory"
        value={showCategories ? "yes" : "no"}
        onChange={handleShowCategoriesChange}
      >
        <FormControlLabel value="yes" control={<Radio />} label="Sim" />
        <FormControlLabel value="no" control={<Radio />} label="Não" />
      </RadioGroup>

      {showCategories && (
        <>
          <span>Lista de Categorias</span>
          <Grid container spacing={2}>
            {columns.map((column, colIndex) => (
              <Grid item xs={4} key={colIndex}>
                <RadioGroup
                  name="tagList"
                  value={selectedTag}
                  onChange={(event) => setSelectedTag(event.target.value)}
                >
                  {column.map((tag) => (
                    <FormControlLabel
                      key={tag.id}
                      value={tag.slug.toString()}
                      control={<Radio />}
                      label={tag.name}
                    />
                  ))}
                </RadioGroup>
              </Grid>
            ))}
          </Grid>
        </>
      )}
    </Grid>
  )
}

export default CategorySelector
